import React from 'react';
import { connect } from 'react-redux';

const Home = props => (
  <div>
    <p>Welcome to AAA Gift Center Portal admin panel</p>
  </div>
);

export default connect()(Home);
